export default __webpack_public_path__ + "static/media/AvatarKids-15.f6dc12ac.png";